module.exports = __webpack_public_path__ + "static/hexomatic-dash-2fc56ae8b19ceb958c7774d47b633ec4.png";